import { flowActivateDataDto, flowUpsertDataDto } from '../dto';
import { BaseApi } from './BaseApi';
export class FlowApi extends BaseApi {
    constructor(config) {
        super(config);
    }
    getFlow(id, withRelatedEntities) {
        return this.providers.makeRequest({
            route: this.buildRoute('flow'),
            params: {
                id,
                withRelatedEntities,
            },
        });
    }
    deleteFlow(id) {
        return this.providers.makeRequest({
            route: this.buildRoute('flow'),
            method: 'DELETE',
            params: {
                id,
            },
        });
    }
    deleteFlows(ids) {
        return this.providers.makeRequest({
            route: this.buildRoute('flows'),
            method: 'DELETE',
            params: {
                ids: ids.join(),
            },
        });
    }
    upsert(flow) {
        const data = flowUpsertDataDto(flow);
        return this.providers.makeRequest({
            route: this.buildRoute('flow'),
            method: 'POST',
            data,
        });
    }
    activateFlow(flow) {
        const id = flow.id;
        const data = flowActivateDataDto(flow);
        return this.providers.makeRequest({
            route: this.buildRoute('flow/activate'),
            method: 'PATCH',
            data,
            params: {
                id,
            },
        });
    }
    deactivateFlow(id) {
        return this.providers.makeRequest({
            route: this.buildRoute('flow/deactivate'),
            method: 'PATCH',
            params: {
                id,
            },
        });
    }
}
//# sourceMappingURL=flowApi.js.map